import { render, staticRenderFns } from "./EditContentChain.vue?vue&type=template&id=48138aa2&scoped=true&"
import script from "./EditContentChain.vue?vue&type=script&lang=js&"
export * from "./EditContentChain.vue?vue&type=script&lang=js&"
import style0 from "./EditContentChain.vue?vue&type=style&index=0&id=48138aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48138aa2",
  null
  
)

export default component.exports